import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=b835daf4&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b835daf4')) {
      api.createRecord('b835daf4', component.options)
    } else {
      api.reload('b835daf4', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=b835daf4&", function () {
      api.rerender('b835daf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rGX9sdqEIXak/JS/cancellationPolicy.vue"
export default component.exports